import { render, staticRenderFns } from "./RealName.vue?vue&type=template&id=f8504642&"
import script from "./RealName.vue?vue&type=script&lang=js&"
export * from "./RealName.vue?vue&type=script&lang=js&"
import style0 from "./RealName.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports